<template>

</template>
<script>
    export default {
        name:'AboutSideBar',
        data(){
            return {
                current_route:this.$route.name,
                current_locale:this.$i18n_global.locale
            }
        },
        methods:{
            checkCurrentRoute(route){
                return (this.current_route == route);
            }
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Pages/AboutSideBar.vue